import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    title:'江西正能智慧科技有限公司',
    pageCount:8,
    selected:0,
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
